import { styled } from '@mui/material/styles';
import { Box, Link, Container } from '@mui/material';

import { VerifyCodeForm } from '../../sections/auth/verify-code/VerifyCodeForm';
import { Typography } from 'components/Typography/Typography';
import { LogoOnlyLayout } from '../../layouts/LogoOnlyLayout';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

const VerifyCode = () => (
  <>
    <LogoOnlyLayout />

    <Container>
      <ContentStyle sx={{ textAlign: 'center' }}>
        <Typography variant="h3" paragraph>
          Please check your email!
        </Typography>

        <Typography sx={{ color: 'text.secondary' }}>
          We have emailed a 6-digit confirmation code to acb@domain, please enter the code in below
          box to verify your email.
        </Typography>

        <Box sx={{ mt: 5, mb: 3 }}>
          <VerifyCodeForm />
        </Box>

        <Typography variant="body2">
          Don’t have a code? &nbsp;
          <Link variant="subtitle2" onClick={() => {}}>
            Resend code
          </Link>
        </Typography>
      </ContentStyle>
    </Container>
  </>
);

export default VerifyCode;
